import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../commons/services/http.service';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { INTERCONEXION_GATEWAY, INTERCONEXION_ICOIJ, INTERCONEXION_RECUPERARPASS, INTERCONEXION_REESTABLECERPASS } from '../../app-module.token';
import { recuperarPassPost, reestablecerPass, responseRecuperarPass } from './recuperarPassword.interface';
import { BaseReponseGeneric } from '../../commons/class/BaseReponseGeneric.interface';

@Injectable({ providedIn: 'root' })
export class recuperarPasswordService {

    private httpService: HttpService = inject(HttpService);
    private icoj = inject(INTERCONEXION_ICOIJ);
    private icoj_gateway = inject(INTERCONEXION_GATEWAY);
    private icoj_recuperar_pass = inject(INTERCONEXION_RECUPERARPASS);
    private icoj_reestablecer_pass = inject(INTERCONEXION_REESTABLECERPASS);

    /**
     * Recupera la contraseña de un usuario, se construye la ruta para la recuperación utilizando la URL raíz, el segmento correspondiente y la función de recuperación, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio como un Observable con un objeto genérico que contiene la información de recuperación de contraseña
     * @param usuario 
     * @returns 
     */
    recuperarPass(usuario: recuperarPassPost): Observable<BaseReponseGeneric<responseRecuperarPass>> {
        const headers = new HttpHeaders();
        const url = `${this.icoj_gateway}${this.icoj}${this.icoj_recuperar_pass}`;
        return this.httpService.postRequest(url, usuario, { headers }) as Observable<BaseReponseGeneric<responseRecuperarPass>>;
    }

    /**
     * Reestablece la contraseña de un usuario, se construye la ruta para el reestablecimiento utilizando la URL raíz, el segmento correspondiente y la función de reestablecimiento, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio como un Observable con un objeto genérico que contiene la información de reestablecimiento de contraseña
     * @param send 
     * @returns 
     */
    reestablecerPassword(send: reestablecerPass): Observable<BaseReponseGeneric<boolean>> {
        const headers = new HttpHeaders();
        const url = `${this.icoj_gateway}${this.icoj}${this.icoj_reestablecer_pass}`;
        return this.httpService.postRequest(url, send, { headers }) as Observable<BaseReponseGeneric<boolean>>;
    }
}